import {
  groq,
  createClient,
  createPortableTextComponent,
  // createPreviewSubscriptionHook,
  createCurrentUserHook,
} from 'next-sanity'
import imageUrlBuilder from '@sanity/image-url'

export const config = {
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET || 'production',
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || 'w7dy66av',
  token: process.env.NEXT_PUPLIC_SANITY_API_TOKEN,
  // useCdn:false — content is read in getStaticProps/getServerSideProps, where
  // freshness matters more than edge caching. With the CDN on, newly published
  // documents returned stale/empty results (a published listing 404'd because an
  // earlier pre-publish read was cached). Sanity recommends useCdn:false for SSG/SSR.
  useCdn: false,
  apiVersion: '2022-01-01',
  perspective: 'published',
}

export const urlFor = (source) => imageUrlBuilder(config).image(source)

// export const usePreviewSubscription = createPreviewSubscriptionHook(config);
// export const PortableText = createPortableTextComponent({
// 	...config,
// 	serializers: {},
// });

export const sanityClient = createClient(config)

// Reads DRAFT documents (server-side only). Must NOT use the CDN (it can't serve
// drafts / authenticated reads), must carry a token, and must use a perspective
// that includes drafts. Falls back across the token names present in this repo.
export const previewClient = createClient({
  ...config,
  useCdn: false,
  token:
    process.env.SANITY_API_TOKEN ||
    process.env.SANITY_WRITE_TOKEN ||
    process.env.NEXT_PUPLIC_SANITY_API_TOKEN,
  perspective: 'previewDrafts',
})

export const getClient = (usePreview) =>
  usePreview ? previewClient : sanityClient
